module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASBAMAAACk4JNkAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURYSMnkdwTIONn4ONnYWNnYSNnYWNn36Pn4WMn4ONnYWNnzyZN+sAAAAKdFJOUz8AwYG8334QLPFw1YFPAAAAWklEQVQI12NYBQQM6MQkVSARpAkkFIWBhKEQCivMBEg4p2JqAxEgUM4AA+UMjRIMUNlEIZg6sCnBRjBTgCZzKEUtUgKzGAWtFggCXeC6ikPFgEUFpkNkFkIvAHj3QbH0cd1WAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-gzh.png
// module id = WpIm
// module chunks = 34